import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';
import type { Day } from '@rover/types';
import { ServiceFrequencyEnum } from '@rover/types/src/ServiceFrequency';

/**
 * Sets the selected days from the array given. ie; [{name: monday}] => monday=true
 * @param searchParams
 * @param selectedDays
 * @param frequency
 */
export const setSelectedDays = (
  searchParams: URLSearchParams,
  selectedDays?: Day[],
  frequency?: ServiceFrequencyEnum
): void => {
  if (selectedDays && frequency === ServiceFrequencyEnum.REPEAT) {
    selectedDays.forEach((day) => {
      searchParams.set(searchFilterKeysMap[day.name.toLowerCase()], true.toString());
    });
  }
};
